import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './HeaderSearchBarNoResults.module.scss';
export const HeaderSearchBarNoResults = ({ message, isMobile = false, isFederatedSearchEnabled }) => (_jsx("div", { className: cx(styles['header__search-bar-empty'], {
        [styles['header__search-bar-mobile']]: isMobile,
        [styles['header__search-bar-empty--center-text']]: isFederatedSearchEnabled && !isMobile
    }), children: message }));
